// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__W1Ryg","noInteraction":"EventWrapper_noInteraction__2iZGa"};